import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DropIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.18005 17H17.8201V18.68H6.18005V17ZM17.8201 9.5L12.0001 15.32L6.18005 9.5H9.50005V4.5H14.5001V9.5H17.8201Z'
                fill='currentColor'
            />
        </>
    ),
})

DropIcon.displayName = 'DropIcon'
